import { z } from "zod";

// CN-14 — the slug rule (letters/digits/dashes, starts with a letter or
// digit) is repeated verbatim across ~14 schemas (Exercise/Muscle/Program/
// Plan/Workout/Bookmark/ExerciseGroup slugs, tag lists, VolumeByMuscle keys).
// Centralized here so they can't drift; only the per-field max length (and,
// for WorkoutExerciseEntry, a custom zod message) varies between call sites.
// NOT for tag.ts's TAG_RE — that one also allows a `namespace:` prefix and
// is a different shape.
export const SLUG_REGEX = /^[a-z0-9][a-z0-9-]*$/;

// Creation paths only: also forbids a trailing dash (`squat-` would be a
// second DDB key next to `squat`). Reads keep the lenient SLUG_REGEX so rows
// already stored stay readable.
export const SLUG_REGEX_STRICT = /^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;

const buildSlug = (re: RegExp, max: number, message?: string) =>
  message
    ? z.string().min(1).max(max).regex(re, message)
    : z.string().min(1).max(max).regex(re);

export const slugString = (max: number, message?: string) =>
  buildSlug(SLUG_REGEX, max, message);

export const slugStringStrict = (max: number, message?: string) =>
  buildSlug(SLUG_REGEX_STRICT, max, message);
